import {k} from '../kaplay.js'
import {makeButton} from '../components.js'
import {bgm, scroll, click} from '../music.js'

k.scene("game", () => {
  bgm.play()
  let timeStart = Date.now()
  const targetScore = {
    sweetness: (() => {
      let min = Math.floor(Math.random() * (8 - 4 + 1)) + 4
      return [min, min+2]
    })(), // random range from 0-10
    taste: [7,10], //should get >8 taste
    weight: (() => {
      let min = Math.floor(Math.random() * (9 - 3 + 1)) + 3
      return [min, min+1]
    })() // should get as close to a certain number
  }

  const sugarData = {
    stevia: {
      sweetnessMultiplier: 5,
      tasteMultiplier: 3,
      tastePenaltyThresholdPercentage: 0.1,
      tastePenaltyMultiplier: 3,
    },
    eryth: {
      sweetnessMultiplier: 2,
      tasteMultiplier: 3,
      tastePenaltyThresholdPercentage: 0.2,
      tastePenaltyMultiplier: 1.5,
    },
    inulin: {
      sweetnessMultiplier: 0.01,
      tasteMultiplier: 0.1,
      tastePenaltyThresholdPercentage: 1,
      tastePenaltyMultiplier: 1,
    },
  }

  let currentScore = {
    sweetness: 0,
    taste: 0,
    weight: 0
  }

  let sugarComposition = {
    stevia: 0,
    eryth: 0,
    inulin: 0
  }

  let activeSlider = null

  const bottle = k.add([
    // k.rect(350, 400),
    // k.color(k.WHITE),
    k.sprite("bottle"),
    k.anchor("bot"),
    k.pos(k.width()/2, k.height()/2 + 30)
  ])

  const {pointer: sweetnessPointer, slider: sweetnessSlider} = makeScoreIndicator(bottle, "sweetness", k.vec2(20, -k.height()/2 + 160), targetScore.sweetness[0], targetScore.sweetness[1])

  const {pointer: tastePointer, slider: tasteSlider} = makeScoreIndicator(bottle, "taste", k.vec2(20, sweetnessSlider._parent.pos.y + 80), targetScore.taste[0], targetScore.taste[1])

  const {pointer: weightPointer, slider: weightSlider} = makeScoreIndicator(bottle, "weight", k.vec2(20, tasteSlider._parent.pos.y + 80), targetScore.weight[0], targetScore.weight[1])


  const sugarContainer = k.add([
    k.anchor("center"),
    k.pos(k.width()/2, k.height()/2 + 90)
  ])

  const steviaSlider = sugarContainer.add([
    // k.rect(20, 280),
    k.sprite("sugar_slider_rail"),
    k.anchor("top"),
    k.pos(-200, 20)
  ])

  const steviaButton = steviaSlider.add([
    // k.rect(80, 40),
    k.sprite("slider_stevia"),
    k.area(),
    // k.color(k.GREEN),
    k.anchor("center"),
    k.pos(0, 253),
    "stevia"
  ])

  const erythSlider = sugarContainer.add([
    // k.rect(20, 280),
    k.sprite("sugar_slider_rail"),
    k.anchor("top"),
    k.pos(0, 20)
  ])

  const erythButton = erythSlider.add([
    // k.rect(80, 40),
    k.sprite("slider_eryth"),
    k.area(),
    // k.color(k.BLUE),
    k.anchor("center"),
    k.pos(0, 253),
    "eryth"
  ])

  const inulinSlider = sugarContainer.add([
    // k.rect(20, 280),
    k.sprite("sugar_slider_rail"),
    k.anchor("top"),
    k.pos(200, 20)
  ])

  const inulinButton = inulinSlider.add([
    // k.rect(80, 40),
    k.sprite("slider_inulin"),
    k.area(),
    // k.color(k.YELLOW),
    k.anchor("center"),
    k.pos(0, 253),
    "inulin"
  ])

  const submitButton = makeButton("LAUNCH", k.vec2(k.width()/2, k.height()/2+35))

  submitButton.onClick(() => {
    console.log({targetScore, currentScore, time: Date.now() - timeStart})
    k.go("result", {targetScore, currentScore, time: Date.now() - timeStart})
    click.play()
  })

  function makeScoreIndicator(_parent, _label, _pos, _minScore, _maxScore) {
    const indicator = _parent.add([
      k.anchor("center"),
      k.pos(_pos),
    ])

    indicator.add([
      k.text(_label, {size: 17, font: "bold", align: "center"}),
      k.color(k.BLACK),
      k.anchor("top"),
      k.pos(0, 12)
    ])

    const range = indicator.add([
      // k.rect(200, 20, {fill: false}),
      k.sprite("progress_range"),
      k.anchor("center"),
      // k.outline(2, k.BLACK)
    ])

    const slider = indicator.add([
      k.sprite("progress_frame"),
      k.anchor("center"),
      k.z(1)
    ])

    const rangeBlock = slider.add([
      // k.rect(slider.width/10 * (_maxScore - _minScore), 18),
      k.rect(233/10 * (_maxScore - _minScore), 14, {radius: 4}),
      k.color(k.GREEN),
      k.anchor("left"),
      k.pos(233/10 * _minScore - 233/2, 0),
    ])

    const pointer = slider.add([
      // k.rect(6, 15),
      // k.outline(2, k.BLACK),
      // k.color(k.YELLOW),
      k.sprite("progress_indicator"),
      k.anchor("center"),
      k.pos(-slider.width/2, -10),
      k.z(2)
    ])

    return {pointer, slider}
  }

  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

  k.onMousePress("left", () => {
    let isPressed = false

    if (steviaButton.hasPoint(k.mousePos())) {
      activeSlider = steviaButton
      isPressed = true
    }
    if (erythButton.hasPoint(k.mousePos())) {
      activeSlider = erythButton
      isPressed = true
    }
    if (inulinButton.hasPoint(k.mousePos())) {
      activeSlider = inulinButton
      isPressed = true
    }

    if (isPressed && scroll.paused) {
      scroll.play()
    }
  })

  k.onMouseRelease("left", () => {
    activeSlider = null
    scroll.stop()
  })

  k.onUpdate(() => {
    if (activeSlider) {
      activeSlider.pos = k.vec2(0, clamp(0, activeSlider._parent.fromScreen(k.mousePos()).y, activeSlider._parent.height))
    }

    let steviaButton = k.get("stevia", {recursive: true})[0]
    let steviaValue = (steviaButton._parent.height - steviaButton.pos.y) / steviaButton._parent.height * 10
    let steviaData = calculateSugar("stevia", steviaValue)

    let erythButton = k.get("eryth", {recursive: true})[0]
    let erythValue = (erythButton._parent.height - erythButton.pos.y) / erythButton._parent.height * 10
    let erythData = calculateSugar("eryth", erythValue)

    let inulinButton = k.get("inulin", {recursive: true})[0]
    let inulinValue = (inulinButton._parent.height - inulinButton.pos.y) / inulinButton._parent.height * 10
    let inulinData = calculateSugar("inulin", inulinValue)
    
    calculateCurrentScore(steviaData, erythData, inulinData)
  })

  function calculateSugar(name, value) {
    let data = sugarData[name]

    sugarComposition[name] = value

    let currentConcentration =  sugarComposition[name] / (10)
    let penaltyEffect = (currentConcentration - data.tastePenaltyThresholdPercentage) / data.tastePenaltyThresholdPercentage
    let taste = sugarComposition[name] * data.tasteMultiplier
    let penalty = taste - sugarComposition[name] * data.tastePenaltyMultiplier * Math.pow(penaltyEffect, 2)

    console.log("penalty:", penalty, currentConcentration, data.tastePenaltyThresholdPercentage)

    return {
      sweetness: sugarComposition[name] * data.sweetnessMultiplier, 
      taste: currentConcentration > data.tastePenaltyThresholdPercentage ? penalty : taste,
      weight: sugarComposition[name]
    }

  }

  function calculateCurrentScore(steviaData, erythData, inulinData) {
    currentScore.sweetness = steviaData.sweetness + erythData.sweetness + inulinData.sweetness
    currentScore.weight = steviaData.weight + erythData.weight + inulinData.weight
    currentScore.taste = steviaData.taste + erythData.taste + inulinData.taste

    console.log(currentScore)

    const overshoot = 18

    sweetnessPointer.pos = k.vec2(clamp(-sweetnessSlider.width/2-overshoot,currentScore.sweetness/10 * sweetnessSlider.width - sweetnessSlider.width/2, sweetnessSlider.width/2+overshoot), -10)
    tastePointer.pos = k.vec2(clamp(-tasteSlider.width/2-overshoot,currentScore.taste/10 * tasteSlider.width - tasteSlider.width/2, tasteSlider.width/2+overshoot), -10)
    weightPointer.pos = k.vec2(clamp(-weightSlider.width/2-overshoot,currentScore.weight/10 * weightSlider.width - weightSlider.width/2, weightSlider.width/2+overshoot), -10)
  }

  k.onDraw(() => {
    k.drawRect({
      width: k.width(),
      height: k.height(),
      color: k.Color.fromHex("#FFF3DE")
    })

    k.drawSprite({
      sprite: "logo",
      pos: k.vec2(10,10)
    })

    k.drawSprite({
      sprite: "table",
      anchor: "top",
      pos: k.vec2(k.width()/2,k.height()/2+25)
    })
  })
})

